import {
    UNAUTHORIZED_ERROR,
    FORBIDDEN_ERROR,
    NOT_FOUND_ERROR,
    UNPROCESSABLE_ENTITY_ERROR,
    SERVER_ERROR,
    INVALID_FORMAT_ERROR,
    TIMEOUT_ERROR,
    UNKNOWN_ERROR,
} from '../constants'
import * as Errors from '../errors'

export function buildClientError (error) {
    if (error instanceof Errors.UnauthorizedError) {
        return { name: UNAUTHORIZED_ERROR }
    }
    if (error instanceof Errors.ForbiddenError) {
        return { name: FORBIDDEN_ERROR }
    }
    if (error instanceof Errors.NotFoundError) {
        return { name: NOT_FOUND_ERROR }
    }
    if (error instanceof Errors.UnprocessableEntityError) {
        return { name: UNPROCESSABLE_ENTITY_ERROR }
    }
    if (error instanceof Errors.ServerError) {
        return { name: SERVER_ERROR }
    }
    if (error instanceof Errors.InvalidFormatError) {
        return { name: INVALID_FORMAT_ERROR }
    }
    if (error instanceof Errors.TimeoutError) {
        return { name: TIMEOUT_ERROR }
    }
    return { name: UNKNOWN_ERROR }
}

export function buildRegistrationError (errors) {
    if (errors.length) {
        return errors
    }

    return [{ message: errors.message }]
}

export function buildError ([firstError = {}]) {
    return {
        message: firstError.message,
    }
}

export function buildFieldError ({ field, message }) {
    return {
        field,
        message,
    }
}

function buildBookingErrorData (error) {
    const data = { ...error.response.data }

    return {
        ...data,
        clientSecret: data.client_secret,
        promoCode: data.promotional_code,
        minPrice: data.code_min_amount,
    }
}

export function buildBookingError (error) {
    if (error instanceof Errors.UnprocessableEntityError) {
        return {
            ...buildClientError(error),
            status: error.response.status,
            data: buildBookingErrorData(error),
        }
    }

    return buildClientError(error)
}

export function buildVehicleError (error) {
    return {
        ...buildClientError(error),
        status: error.status,
    }
}

export function buildBookingAvailabilityError (errors) {
    if (errors.length) {
        return errors.map(buildFieldError)
    }

    return [
        {
            message: errors.message,
        },
    ]
}

export function buildLoginError (errors) {
    if (errors.length) {
        return buildFieldError(errors[0])
    }

    return {
        status: errors.status,
        message: errors.message,
    }
}

export function buildDeleteVehicleError (error) {
    return {
        status: error.status,
        message: error.message,
    }
}
